import React from 'react';
import VisualSetupSection from '../components/VisualSetupSection';
import constants from '../../../utils/constants';

const ManagerVisualSetup = ({ manager }) => (
  <React.Fragment>
    <VisualSetupSection
      entityType="manager"
      entityId={manager.id}
      sectionTitle="Manager Image"
      images={['photo_thumbnail', 'photo_full']}
      uploadSize={{
        width: constants.images.manager.photo_full.uploadWidth,
        height: constants.images.manager.photo_full.uploadHeight,
      }}
      defaultExpand
      useCroppie
    />
  </React.Fragment>
);
export default ManagerVisualSetup;
